/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Types_Credential_RemovedInputs */

const es_admin_traces_types_credential_removed = /** @type {(inputs: Admin_Traces_Types_Credential_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credencial eliminada`)
};

const en_admin_traces_types_credential_removed = /** @type {(inputs: Admin_Traces_Types_Credential_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential removed`)
};

/**
* | output |
* | --- |
* | "Credential removed" |
*
* @param {Admin_Traces_Types_Credential_RemovedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_types_credential_removed = /** @type {((inputs?: Admin_Traces_Types_Credential_RemovedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Types_Credential_RemovedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_types_credential_removed(inputs)
	return en_admin_traces_types_credential_removed(inputs)
});
export { admin_traces_types_credential_removed as "admin.traces.types.credential_removed" }